import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="b"
      viewBox="0 0 239 239"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <path d="M119.5,187.7c-37.6,0-68.2-30.6-68.2-68.2s30.6-68.2,68.2-68.2,68.2,30.6,68.2,68.2-30.6,68.2-68.2,68.2Z" />
        <path d="M119.5,39.3c-1.9,0-3.5-1.6-3.5-3.5V3.5c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5v32.3c0,1.9-1.6,3.5-3.5,3.5Z" />
        <path d="M178.7,63.8c-.9,0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6,0-5l22.9-22.9c1.4-1.4,3.6-1.4,4.9,0s1.4,3.6,0,5l-22.9,22.9c-.7.7-1.6,1-2.5,1h0Z" />
        <path d="M235.5,123h-32.3c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h32.3c1.9,0,3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5Z" />
        <path d="M201.5,205c-.9,0-1.8-.3-2.5-1l-22.9-22.9c-1.4-1.4-1.4-3.6,0-4.9s3.6-1.4,4.9,0l22.9,22.9c1.4,1.4,1.4,3.6,0,4.9s-1.6,1-2.5,1h0Z" />
        <path d="M119.5,239c-1.9,0-3.5-1.6-3.5-3.5v-32.3c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5v32.3c0,1.9-1.6,3.5-3.5,3.5Z" />
        <path d="M37.5,205c-.9,0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6,0-4.9l22.9-22.9c1.4-1.4,3.6-1.4,5,0s1.4,3.6,0,4.9l-22.9,22.9c-.7.7-1.6,1-2.5,1h0Z" />
        <path d="M35.8,123H3.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h32.3c1.9,0,3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5Z" />
        <path d="M60.3,63.8c-.9,0-1.8-.3-2.5-1l-22.9-22.9c-1.4-1.4-1.4-3.6,0-5s3.6-1.4,5,0l22.9,22.9c1.4,1.4,1.4,3.6,0,5s-1.6,1-2.5,1h0Z" />
      </g>
    </svg>
  )
}
export default Icon
